import { Link } from '@mui/material';

import { ROUTES } from '@/constants/routes';

/**
 * "the Terms of Service and Privacy Policy", as two links — the copy every consent checkbox on this
 * form set uses (`AcceptTermsCheckbox` on registration, the OAuth first-time-registration consent
 * step in `SocialLoginButtons`). Pulled out once so both cannot drift into linking different routes or
 * wording the same agreement differently.
 *
 * Opens in a new tab: dismissing either dialog to go read the terms must not lose whatever the person
 * had already filled in or clicked through.
 */
export function TermsAndPrivacyLinks() {
  return (
    <>
      <Link href={ROUTES.legalTerms} target="_blank" rel="noopener noreferrer">
        Terms of Service
      </Link>{' '}
      and{' '}
      <Link href={ROUTES.legalPrivacy} target="_blank" rel="noopener noreferrer">
        Privacy Policy
      </Link>
    </>
  );
}
